module.exports = __webpack_public_path__ + "static/MiguelA-8473b4b66408bb70a9f40f60f00822d5.gif";